<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch18"></a><a id="page_19"></a><a href="#/contents#ch18"><b>The Senses</b></a></h2>
<p class="noindent"><span>On average, human taste buds live only 7 to 10 days before they die and are replaced with new ones.</span></p>
<p class="noindent"><span>A cricket’s hearing organ is located in its front legs.</span></p>
<p class="noindent"><span>Your tongue can detect sweetness in a solution of 1 part sugar to 200 parts water.</span></p>
<p class="noindent"><span>Snakes have no ears, but they can still “hear.” Their tongues sense sound vibrations.</span></p>
<p class="noindent"><span>The human eye can tell the difference between about 500 shades of gray.</span></p>
<p class="noindent"><span>If you lost an eye, you would lose only about 20 percent of your vision.</span></p>
<p class="noindent"><span>Women tend to have wider peripheral vision than men do.</span></p>
<p class="noindent"><span>Animal and fish brains devote more space to the sense of smell than human brains do.</span></p>
<p class="noindent"><span>The cornea is the only body part with no blood supply. It gets oxygen directly from the air.</span></p>
<p class="noindent"><span>First sense to develop in human infants: touch.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter18.vue?61127d42